import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  getWishlist,
  removeFromWishlist,
  clearWishlist,
} from "../services/authenticatedRequests";
import { S3_URL_PRODUCTS } from "../utils/constants";
import { toast } from "react-toastify";
import { useCart } from "../contexts/CartContext";
import LoadingComponent from "./LoadingComponent";
import NoResultsComponent from "./NoResultsComponent";

const WishListSection = () => {
  document.title = `Wishlist | Bigmall`;
  const { addToCart } = useCart();
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  //console.log(S3_URL_PRODUCTS);

  useEffect(() => {
    const fetchWishlist = async () => {
      setLoading(true);
      try {
        const response = await getWishlist();
        //  console.log(response);
        setWishlist(response);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchWishlist();
  }, []);

  const handleRemoveFromWishlist = async (productId) => {
    try {
      await removeFromWishlist(productId);
      window.dispatchEvent(new Event("wishlistUpdated"));
      setWishlist(wishlist.filter((item) => item.id !== productId));
      toast.success("Item removed from wishlist");
    } catch (error) {
      console.error(error);
    }
  };

  //need a confirm alert pop up to clear the wishlist
  const handleClearWishlist = async () => {
    // Show confirmation alert
    if (!window.confirm("Are you sure you want to clear your wishlist?")) {
      return; // Exit if the user cancels
    }
    try {
      await clearWishlist();
      setWishlist([]);
      toast.success("Wishlist cleared");
      //navigate("/");
      window.dispatchEvent(new Event("wishlistUpdated"));
    } catch (error) {
      console.error(error);
    }
  };
  const handleAddToCart = (id, e) => {
    e.preventDefault();
    // Do nothing if out of stock

    try {
      addToCart({ id, quantity: 1 });
      //toast.success("Item added to cart");
      //handleRemoveFromWishlist(id);
    } catch (error) {
      console.error(error);
      toast.error("Failed to add item to cart");
    }
  };

  if (loading) {
    return <LoadingComponent message="Wishlist loading..." />;
  }
  if (wishlist.length === 0) {
    return <NoResultsComponent message="Your wishlist is empty. Start shopping now..." />;
  }
  return (
    <section className="cart py-20">
      <div className="container container-lg">
        <div className="row gy-4">
          <div className="col-lg-11">
            <div className="cart-table border border-gray-100 rounded-8 py-10 px-10">
              <div className="overflow-x-auto scroll-sm scroll-sm-horizontal">
                <table className="table style-two">
                  <thead>
                    <tr>
                      <th className="h6 text-sm fw-bold">Product</th>
                      <th className="h6 text-sm fw-bold">Unit Price</th>
                      <th className="h6 text-sm fw-bold">Added Date</th>
                      <th className="h6 text-sm fw-bold">Action</th>
                      <th className="h6 text-sm fw-bold">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {wishlist.map((item) => (
                      <tr key={item.id}>
                        <td>
                          <div className="table-product d-flex align-items-center">
                            <Link
                              to={`/product-details/${item.id}`}
                              className="table-product__thumb flex-center"
                            >
                              <img
                                src={
                                  item.images && item.images.length > 0
                                    ? `${S3_URL_PRODUCTS}${item.images[0]}`
                                    : "assets/images/placeholder.png"
                                }
                                alt={item.name}
                              />
                            </Link>
                            <div className="table-product__content text-start">
                              <h6 className="title text-sm fw-semibold mb-8">
                                <Link
                                  to={`/product-details/${item.id}`}
                                  className="link text-line-2"
                                >
                                  {item.name.length > 50
                                    ? `${item.name.slice(0, 50)}...`
                                    : item.name}
                                </Link>
                              </h6>
                            </div>
                          </div>
                        </td>
                        <td>
                          {(() => {
                            const config = item.configuration;
                            const configDiscount =
                              config?.Sale?.collectionConfiguration?.discount ||
                              0;
                            const discountActive =
                              config &&
                              configDiscount &&
                              config.Sale.configStatus === "active";

                            let computedSalePrice, discountPercentage;

                            if (discountActive) {
                              if (item.salePrice) {
                                // Case 1: Active config & sale price exists
                                computedSalePrice =
                                  item.salePrice * (1 - configDiscount / 100);
                                discountPercentage = Math.round(
                                  ((item.regularPrice - computedSalePrice) /
                                    item.regularPrice) *
                                    100
                                );
                              } else {
                                // Case 3: Active config but no sale price
                                computedSalePrice =
                                  item.regularPrice *
                                  (1 - configDiscount / 100);
                                discountPercentage = configDiscount; // directly use the config discount
                              }
                            } else {
                              // Cases 2 & 4: No active config; use salePrice if available or regularPrice
                              computedSalePrice =
                                item.salePrice || item.regularPrice;
                              if (item.salePrice) {
                                discountPercentage = Math.round(
                                  ((item.regularPrice - item.salePrice) /
                                    item.regularPrice) *
                                    100
                                );
                              }
                            }

                            // If there's a discount (i.e. effective price is lower than the regular price), show both prices.
                            if (computedSalePrice < item.regularPrice) {
                              return (
                                <div className="d-flex flex-column">
                                  <span className="text-gray-400 text-sm fw-semibold text-decoration-line-through">
                                    LKR {item.regularPrice.toFixed(2)}
                                  </span>
                                  <span className="text-heading text-sm fw-semibold ml-8">
                                    LKR {computedSalePrice.toFixed(2)}
                                  </span>
                                  <span className="text-main text-sm fw-semibold ml-4">
                                    ({discountPercentage}% off)
                                  </span>
                                </div>
                              );
                            } else {
                              return (
                                <span className="text-heading text-sm fw-semibold">
                                  LKR {item.regularPrice.toFixed(2)}
                                </span>
                              );
                            }
                          })()}
                        </td>
                        <td>
                          {new Date(item.createTime).toLocaleString("en-US", {
                            year: "numeric",
                            month: "long", // e.g., April
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                          })}
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-main btn-sm btn-rounded"
                            onClick={(e) => handleAddToCart(item.id, e)}
                          >
                            Add to Cart
                          </button>
                        </td>
                        <td>
                          <button
                            type="button"
                            className="text-danger-600 btn btn-lg"
                            onClick={() => handleRemoveFromWishlist(item.id)}
                          >
                            <i className="ph ph-trash text-lg d-flex" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            {/* {wishlist.length > 0 && ( */}
            <div className="mt-10 d-flex align-items-center justify-content-end">
              <button
                type="button"
                onClick={handleClearWishlist}
                className="btn btn-danger btn-sm d-flex align-items-center"
              >
                <i className="ph ph-trash-simple text-sm me-2" />
                Clear Wishlist
              </button>
            </div>
            {/* )} */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WishListSection;
